const statisticsEn = {
    "monthly_comparison": {
        "mom": "MoM",
        "no_data_yoy": "No data for one year ago.",
        "no_data_mom": "No data for the previous month.",
        "not_enough_history": "At least one full closed month is needed for the comparison.",
        "load_failed": "Failed to load the data.",
        "based_on_days": "based on d1-d{{days}}",
        "units": {
            "pcs": "pcs",
            "guests": "guests",
            "pp": "pp",
        },
        "charts": {
            "trailing_title": "Guests — 12-month context",
            "trailing_to_date_note": "Every month is limited to the first {{days}} days.",
            "other_months": "Other months",
            "table_view": "Table",
            "category": "Category",
            "no_data": "No data for the selected month.",
            "breakdown": {
                "source": "Reservations by source",
                "status": "Reservations by status",
                "country": "Domestic and foreign reservations",
                "daypart": "Reservations by time of day",
            },
        },
        "dayparts": {
            "morning": "Morning 6–11",
            "lunch": "Lunch 11–15",
            "afternoon": "Afternoon 15–18",
            "dinner": "Dinner 18–22",
            "evening": "Evening 22+",
        },
        "kpi": {
            "reservations_total": "Reservations",
            "reservations_confirmed": "Confirmed reservations",
            "guests_total": "Guests",
            "avg_party_size": "Average party size",
            "no_show_rate": "No-show rate",
            "cancellation_rate": "Cancellation rate",
            "voucher_sold_count": "Vouchers sold (pcs)",
            "voucher_sold_value": "Voucher sales value",
        },
    },
    "reviews": {
        "average_score": "Average score",
        "review_count": "Number of reviews",
        "rating": "Overall",
        "food_rating": "Food",
        "service_rating": "Service",
        "atmosphere_rating": "Atmosphere",
        "text_rating": "Written review",
        "stars": "{{count}} stars",
        "detailed_report_title": "Detailed report",
        "detailed_report_subtitle": "Custom date range",
        "trends": {
            "section_title": "Trend overview",
            "section_subtitle": "Last 6 months or last year, at a glance",
            "rating_trend_title": "Average ratings over time",
            "review_count_title": "Number of reviews over time",
            "monthly": "Monthly",
            "weekly": "Weekly",
            "last_year": "Last year",
            "last_6_months": "Last 6 months",
        },
    },
}

export default statisticsEn;
